<app-review-section
  [title]="'facilities-data.releases-title' | translate"
  [tooltip]="'tooltips.facilities-data.releases' | translate"
  [sectionId]="sectionIdentifier.TechnicalData_Releases"
  [applicationId]="applicationId"
  [isDetailsView]="isDetailsView"
  [showButtonsPredicate]="hideButtonsForEmployeeWhenHasChimneySweeper">
  <span class="component-container base-data-container">
    <form [formGroup]="releasesFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
      <div class="form-background">
        <div class="ui-g-12 checkbox-columns">
          <div *ngFor="let label of releasesCheckboxLabels; let i = index">
            <p-checkbox
              appEnterClick
              [formControlName]="label.controlName"
              [label]="getCheckBoxLabel(label.labelName) | translate"
              [readonly]="isReadOnly"
              binary="true"
              id="{{ label }}"></p-checkbox>
            <label class="ui-g-5" for="{{ label }}"></label>
          </div>
        </div>
      </div>
    </form>
  </span>
</app-review-section>
